import SupplierScreen from './Supplier'

export default SupplierScreen
